export const SUPPORTED_IMAGE_RATIOS = Object.freeze([
  '1:1',
  '3:2',
  '2:3',
  '4:3',
  '3:4',
  '5:4',
  '4:5',
  '16:9',
  '9:16',
  '2:1',
  '1:2',
  '21:9',
  '9:21'
])

export const DEFAULT_IMAGE_RATIO = '16:9'
export const LOCAL_RESIZE_RATIO_TOLERANCE_PERCENT = 0.5

export function isExactAspectRatio(width, height, ratioWidth = 16, ratioHeight = 9) {
  const actualWidth = Number(width)
  const actualHeight = Number(height)
  const targetWidth = Number(ratioWidth)
  const targetHeight = Number(ratioHeight)
  return Number.isInteger(actualWidth) && Number.isInteger(actualHeight) &&
    actualWidth > 0 && actualHeight > 0 && targetWidth > 0 && targetHeight > 0 &&
    actualWidth * targetHeight === actualHeight * targetWidth
}

export function isAspectRatioWithinTolerance(
  width,
  height,
  ratioWidth = 16,
  ratioHeight = 9,
  tolerancePercent = LOCAL_RESIZE_RATIO_TOLERANCE_PERCENT
) {
  const actualWidth = Number(width)
  const actualHeight = Number(height)
  const targetRatio = Number(ratioWidth) / Number(ratioHeight)
  const tolerance = Number(tolerancePercent)
  if (!Number.isFinite(actualWidth) || !Number.isFinite(actualHeight) ||
      actualWidth <= 0 || actualHeight <= 0 || !Number.isFinite(targetRatio) ||
      targetRatio <= 0 || !Number.isFinite(tolerance) || tolerance < 0) return false
  const differencePercent = Math.abs(actualWidth / actualHeight - targetRatio) / targetRatio * 100
  return differencePercent <= tolerance
}

function ratioValue(ratio) {
  const [width, height] = String(ratio || '').split(':').map(Number)
  return width > 0 && height > 0 ? width / height : 0
}

/**
 * Generation APIs accept named aspect ratios rather than arbitrary pixel sizes.
 * Use logarithmic distance so landscape and portrait ratios are treated evenly.
 */
export function closestImageRatio(width, height, options = SUPPORTED_IMAGE_RATIOS, fallback = DEFAULT_IMAGE_RATIO) {
  const sourceRatio = Number(width) / Number(height)
  const supported = Array.from(options || [])
    .map(option => typeof option === 'string' ? option : option && option.value)
    .filter(option => ratioValue(option) > 0)

  if (!Number.isFinite(sourceRatio) || sourceRatio <= 0 || !supported.length) {
    return supported.includes(fallback) ? fallback : (supported[0] || fallback)
  }

  return supported.reduce((best, ratio) => {
    const distance = Math.abs(Math.log(sourceRatio / ratioValue(ratio)))
    return distance < best.distance ? { ratio, distance } : best
  }, { ratio: supported[0], distance: Number.POSITIVE_INFINITY }).ratio
}

export function readImageDimensions(source) {
  return new Promise((resolve, reject) => {
    const objectUrl = typeof source === 'string' ? source : URL.createObjectURL(source)
    const shouldRevoke = typeof source !== 'string'
    const image = new Image()

    const cleanUp = () => {
      if (shouldRevoke) URL.revokeObjectURL(objectUrl)
    }

    image.onload = () => {
      const dimensions = { width: image.naturalWidth, height: image.naturalHeight }
      cleanUp()
      resolve(dimensions)
    }
    image.onerror = () => {
      cleanUp()
      reject(new Error('图片尺寸读取失败'))
    }
    image.src = objectUrl
  })
}
